import 'normalize.css/normalize.css';
import './src/css/main.css';
import './src/css/prismjs.css';


import muiRootWrapper from './src/mui-root-wrapper';
export const wrapRootElement = muiRootWrapper;
